export function isProduction(): boolean {
  return window?.location?.href?.includes('app.designrr.io')
}

export function isStage(): boolean {
  return window?.location?.href?.includes('stage.designrr.io')
}
